var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackgroundColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1634.000000, -217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-background-color",
    transform: "translate(1635.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,12.7826087 C15,12.11 13.75,10.3478261 13.75,10.3478261 C13.75,10.3478261 12.5,12.11 12.5,12.7826087 C12.5,13.4552174 13.059375,14 13.75,14 C14.440625,14 15,13.4552174 15,12.7826087 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625,0 L13.75,7.91304348",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.2173913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87125,7.80347826 L7.316875,13.2129565 C7.19875,13.328 7.041875,13.3913043 6.875,13.3913043 C6.708125,13.3913043 6.55125,13.328 6.433125,13.2129565 L0.183125,7.126 C0.065,7.01095652 0,6.85817391 0,6.69565217 C0,6.53313043 0.065,6.38034783 0.183125,6.26530435 L5.7375,0.855826087",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.2173913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    points: "6.875 13.3913043 0 6.69565217 13.125 6.69565217 13.125 7.30434783"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackgroundColor);
export default __webpack_public_path__ + "static/media/icon-background-color.018401cd80f2afcc351165a6c1e08f76.svg";
export { ForwardRef as ReactComponent };